<template lang="pug">
  b-card.manager-organizations-categories-form.card-white.card-no-gutters.shadow(no-body)
    wc-card-tabs(:tabs='tabs')
    b-form.form-wc.form-organizations-category-form.mt-sm-3(
      @submit.stop.prevent='formSubmit'
      @input.stop.prevent='formChange'
      @reset.stop.prevent='formReset')
      b-card-body

        wc-forms-alerts(v-if='formShowErrors' :errors='form.errors.base')

        transition(name='fade')
          fieldset(v-if='formShow' :disabled='formDisable')
            b-form-group#form-categories-organization_categories(
              :label="$t('activerecord.models.category.other')"
              label-for='categories-category_ids'
              label-cols-md='2'
              label-align-md='right')
              multiselect#categories-category_ids.shadow-sm.custom-select(
                name='organization_categories'
                v-model='categoriesCategoryIdsSelected'
                :multiple='true'
                :options='form.selects.categoriesCategoryIdsOptions'
                :class='formValidationClass($v.form.data.attributes.category_ids)'
                :close-on-select='true'
                :clear-on-select='true'
                :placeholder="$t('category.placeholders.organizations')"
                label='label'
                track-by='value'
                :internal-search='false'
                :selectLabel="$t('shared.forms.multiselect.select_label')"
                :selectedLabel="$t('shared.forms.multiselect.selected_label')"
                :deselectLabel="$t('shared.forms.multiselect.deselect_label')"
                :limitText="count => $t('shared.forms.multiselect.limit_text', { count: count })"
                :max='$wc.conf.limits.max_organization_categories'
                :loading='form.selects.categoriesCategoryIdsLoading'
                @search-change='searchCategories'
                @input='formSelectOption')
                span(slot='noResult')
                  | {{ $t('shared.forms.multiselect.no_result') }}
                span(slot='noOptions')
                  | {{ $t('shared.forms.multiselect.no_options_search') }}
                span(slot='maxElements')
                  | {{ $t('shared.forms.multiselect.max_elements', { count: $wc.conf.limits.max_organization_categories }) }}
              wc-forms-if#categories-category_ids-feedback(
                extra-class='ml-feedback'
                :attribute='$v.form.data.attributes.category_ids'
                :remote="formRemoteInvalidFeedback('category_ids')"
                :validators='{}')

      b-card-footer.border-0.bg-white
        wc-forms-buttons#form-categories-buttons(:disabled='formDisable || $v.form.data.$invalid')

    loading(:active.sync='isLoading' :can-cancel-esc='true' :on-cancel='onCancel')
</template>

<script>
import Tabs from '@views/container/manager/organizations/shared/tabs'
import WcFormsButtons from '@components/shared/forms/WcFormsButtons'
import apiCategories from '@services/api/manager/organizations/categories'
import { Form, mapSelects } from '@common/form'

export default {
  name: 'manager-organizations-categories-form',
  mixins: [Tabs, Form],
  components: {
    WcFormsButtons,
  },
  computed: {
    ...mapSelects([
      {
        name: 'categoriesCategoryIds',
        default: 'relationships.categories.data',
        attribute: 'attributes.category_ids',
        included: {
          type: 'category',
          key: 'id',
          value: 'attributes.name_humanized',
        },
        multiselect: { key: 'id' },
      },
    ]),
    apiParams() {
      return {
        get: [{ organization_id: this.organization_id }],
        update: [
          { organization_id: this.organization_id },
          { [this.apiModel]: this.formSubmitData(this.$getDeep(this.form, 'data.attributes')) },
        ],
        categoriesCategoryIdsSearch: [
          { organization_id: this.organization_id },
          { term: this.form.selects.categoriesCategoryIdsTerm },
        ],
      }
    },
  },
  methods: {
    searchCategories(term, id) {
      this.formMultiselectSearch(term, id, 'searchCategories', 'name_humanized')
    },
    apiCallback(callback) {
      if (callback === 'submit-success') this.$emit('categories-changed')
    },
  },
  validations() {
    return {
      form: {
        data: {
          attributes: {
            category_ids: {
              remote: () => this.formRemoteValid('category_ids'),
            },
          },
        },
      },
    }
  },
  data() {
    return {
      apiBase: apiCategories,
      apiModel: 'categories',
      organization_id: this.$route.params.organization_id,
      asyncDataSelects: ['categoriesCategoryIds'],
    }
  },
}
</script>
